// extracted by mini-css-extract-plugin
export var errorFlatButton = "error-flat-button_aYHbxLk_YBI371A7qWyv";
export var errorFlatButtonTooltip = "error-flat-button__tooltip_wjgl9rlbaIHfcpOyQkTL";